<div class="divcontainer">
    <div class="container">
        <img src="../../../assets/images/undraw_page_not_found_su7k.svg" width="500">
        <h1>Opa... A página que você está procurando não existe.</h1>
        <button class="btn btn-success btn-madelife" (click)="voltarHome()">Voltar a Home</button>
    </div>
</div>